import { LOCATION_CHANGE } from 'connected-react-router';

import { ADD as ENTITIES_USER_ADD } from 'entities/user/constants';
import { selectLocalSetting } from 'localSettings/selectors';
import { metrics as metricsLib } from 'metrics';
import { baseFontSize } from 'metrics/util';
import config from 'config';

import { trackProfileActions } from './profile';

export const metrics = (store) => (next) => (action) => {
  trackProfileActions(store, action);

  const { configure, pageView, trackReduxAction } = metricsLib.api;
  const timeZone = selectLocalSetting(store.getState(), 'timeZone');

  configure([
    {
      traits: {
        // eslint-disable-next-line camelcase
        base_font_size: baseFontSize,
        environment: config.environment,
      },
      context: {
        timezone: timeZone ?? Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone,
      },
      properties: {
        environment: config.environment,
      },
    },
  ]);

  switch (action.type) {
    case LOCATION_CHANGE: {
      pageView(action.payload.location);
      break;
    }

    case ENTITIES_USER_ADD: {
      const { user } = action;

      trackReduxAction([action, user.toSegmentIdentity()]);
      break;
    }

    default:
      break;
  }

  next(action);
};

export default metrics;
